import { Button, Tooltip, message } from "antd"
import React, { memo, FC } from "react"
import { FieldErrorsType } from "./RegistrationPanel"
import { BookerInput, ThirdPartyLoginInput } from "../../generated/graphql"
import { FormikProps } from "formik"
import { RegistrationPanelValidationType } from "./RegistrationPanelValidationSchema"
import { Maybe } from "graphql/jsutils/Maybe"
import { sanatizeErrors } from "./loginRegisterHelpers"
import { useTranslation } from "react-i18next"

export type RegistrationPanelStepButtonsProps = {
    registrationPanelStepButtonsProps: {
        step: number
        formikProps: FormikProps<RegistrationPanelValidationType>
        nextStep: (errors: FieldErrorsType, thirdPartyUserFields: Array<keyof ThirdPartyLoginInput | "passwordConfirmation">, formikProps: FormikProps<RegistrationPanelValidationType>) => void
        thirdPartyUserFields: Array<keyof ThirdPartyLoginInput | "passwordConfirmation">
        bookerDataFields: Array<keyof BookerInput>
        emailIsUnique: boolean
        // Mitarbeiter-Zugang ohne Kundenkonto: Registrierung ist gesperrt, nur der Admin legt den Bucher an
        emailTakenByStaff?: boolean
        noBookerDataFieldIsTouched: boolean
        isLoading: boolean
        createOrUpdate: (formikProps: FormikProps<RegistrationPanelValidationType>) => void
        useCase: "registration" | "account"
        useCaseLabel: string
        loadingFetchedBookerData: boolean
        refetchBookerData: (formikProps: FormikProps<RegistrationPanelValidationType>) => void
    }
}

const RegistrationPanelStepButtons: FC<RegistrationPanelStepButtonsProps> = ({ registrationPanelStepButtonsProps }) => {
    const { t } = useTranslation()
    const { step, formikProps, nextStep, thirdPartyUserFields, isLoading, createOrUpdate, useCase, useCaseLabel, loadingFetchedBookerData, refetchBookerData, emailTakenByStaff = false } =
        registrationPanelStepButtonsProps

    const { values } = formikProps

    const userNameIsValid = values?.username !== "" && values?.username !== undefined && formikProps.errors.username === undefined

    const passwordFieldsAreValid =
        values?.password !== "" &&
        values?.password !== undefined &&
        values?.passwordConfirmation !== "" &&
        values?.passwordConfirmation !== undefined &&
        values?.password === values?.passwordConfirmation

    const errors = formikProps.errors
    const registrationErrors = Object.keys(errors).filter((key) => {
        return thirdPartyUserFields.includes(key as keyof ThirdPartyLoginInput)
    })
    const toolTipTextPasswordRegistration = errors.username ?? errors.password ?? errors.passwordConfirmation

    if (step === 0) {
        return (
            <>
                <Tooltip title={toolTipTextPasswordRegistration}>
                    <Button
                        data-testid='registration-next-button'
                        type={userNameIsValid && passwordFieldsAreValid ? "primary" : "default"}
                        htmlType='submit'
                        onClick={() => nextStep(formikProps.errors, thirdPartyUserFields, formikProps)}
                        block
                        disabled={registrationErrors.length > 0 || emailTakenByStaff}
                    >
                        {t("registrationPanelStepButtons.next", "Weiter")}
                    </Button>
                </Tooltip>
                {/* <Tooltip title={toolTipTextPasswordRegistration}>
                    <Button
                        type={userNameIsValid && passwordFieldsAreValid ? "primary" : "default"}
                        htmlType='submit'
                        onClick={() => nextStep(formikProps.errors, thirdPartyUserFields, formikProps)}
                        block
                        disabled={registrationErrors.length > 0}
                    >
                        Mit Passwort registrieren
                    </Button>
                </Tooltip>
                <Divider
                    children={"oder"}
                    plain
                    style={{
                        lineHeight: 0,
                        borderColor: "lightgrey",
                        color: grey[5],
                        marginTop: 5,
                    }}
                />
                <Tooltip title={toolTipTextPasswordlessRegistration}>
                    <Button
                        type={userNameIsValid ? "primary" : "default"}
                        // htmlType='submit'
                        //  onClick={() => nextStep(formikProps.errors, thirdPartyUserFields, formikProps)}
                        block
                        disabled={registrationErrors.includes("username")}
                        style={{ marginTop: 5 }}
                    >
                        Ohne Passwort registrieren
                    </Button>
                </Tooltip> */}
            </>
        )
    }

    const sanatizedErrors = sanatizeErrors(formikProps).sanatizedErrors
    const hasErrors = sanatizeErrors(formikProps).hasErrors
    const buttonDisabled = hasErrors

    if (buttonDisabled) {
        console.group("Button Disabled")
        console.log("600 dirty", formikProps.dirty)
        console.log("601 hasErrors", hasErrors)
        console.log("602 formikProps.errors", formikProps.errors)
        const allPaymentMethods = formikProps.values?.paymentMethods ?? []
        console.log("603 allPaymentMethods", allPaymentMethods)
        const paymentMethods = formikProps.values?.paymentMethods ?? []
        console.log("604paymentMethods", paymentMethods)
        console.log("605 sanatizedErrors", sanatizedErrors)
        console.groupEnd()
    }

    const createOrUpdateWithFeedback = (formikProps: FormikProps<RegistrationPanelValidationType>) => {
        createOrUpdate(formikProps)
        if (!hasErrors && !isLoading) {
            message.success("Ihre Daten wurden erfolgreich gespeichert!")
        }
    }

    return (
        <div style={{ width: "100%" }}>
            <Button
                data-testid='registration-submit-button'
                // type='primary'
                type={formikProps.dirty ? "primary" : "default"}
                htmlType='submit'
                block
                disabled={buttonDisabled}
                // disabled={hasErrors}
                loading={isLoading || loadingFetchedBookerData}
                onClick={() => createOrUpdateWithFeedback(formikProps)}
            >
                {useCase === "registration" ? useCaseLabel : "speichern"}
            </Button>
            {useCase === "account" && (
                <Button style={{ marginTop: 5 }} type='link' block loading={loadingFetchedBookerData} onClick={() => refetchBookerData(formikProps)}>
                    {t("registrationPanelStepButtons.resetValues", "Werte Zurücksetzen")}
                </Button>
            )}
        </div>
    )
}

export default memo(RegistrationPanelStepButtons)
